
import { getEmployments } from 'src/store/employment/employment.selector';
import { getActiveBorrowerAccount, getItemsByIdResources, getItemsByIdResourcesWithActiveLoanRole } from 'src/store/store.helpers';
import { USER_REDUX_RESOURCE_NAME } from 'src/store/constants';
import store from 'src/store';
import { lensPath, set, compose, pathOr, head, values } from 'ramda';
import { USER_WORKFLOW_INTENT } from 'src/services/constants';

/**
 * @deprecated needs to write with ReduxStateStore it do the same fetch resources details from redux store
*/
export const getStateFromStore = (singleSiteIntent?: any) => {
  const state = store.getState();
  const updatePwd = compose(set(lensPath(['password']), '   '))
  const borrowerAccount = getActiveBorrowerAccount(state);
  const userSpecificIntent = pathOr({}, [0], getItemsByIdResourcesWithActiveLoanRole(USER_WORKFLOW_INTENT, state))
  const userSpecificIntents = getItemsByIdResources(USER_WORKFLOW_INTENT, state);

  return {
    loanApp : pathOr({}, [USER_REDUX_RESOURCE_NAME, 'loanApp', 'data'], state),
    accounts: updatePwd(borrowerAccount),
    account: pathOr({}, ['accounts', 'data'], state),
    business: pathOr({}, [USER_REDUX_RESOURCE_NAME, 'business', 'data'], state),
    employment: getEmployments(
      getItemsByIdResourcesWithActiveLoanRole('employments', state),
      singleSiteIntent
    ),
    employments: getItemsByIdResourcesWithActiveLoanRole('employments', state),
    borrower: head(getItemsByIdResourcesWithActiveLoanRole('borrowers', state)),
    declaration: head(getItemsByIdResourcesWithActiveLoanRole('declarations', state)),
    monthlyIncome: head(getItemsByIdResourcesWithActiveLoanRole('monthlyIncome', state)),
    assets: head(getItemsByIdResourcesWithActiveLoanRole('assets', state)),
    liabilities: head(getItemsByIdResourcesWithActiveLoanRole('liabilities', state)),
    lendingTerm: head(getItemsByIdResourcesWithActiveLoanRole('lendingTermsApplicant', state)),
    userSpecificIntent,
    loanUsersSpecificIntents: userSpecificIntents,
    property: head(
      values(
        pathOr(
          {},
          [USER_REDUX_RESOURCE_NAME, 'propertiesApplicant', 'itemsById'],
          state
        )
      )
    ),
  };
};
